import ApiService from "@/api.service";
import API from "@/API";

export const GET_NEW_POST_CONFIG = "getListNewPostConfig";
export const SET_NEW_POST_CONFIG = "setListNewPostConfig";
export const ADD_NEW_POST_CONFIG = "addNewPostConfig";

export const GET_DETAIL_NEW_POST_CONFIG = "getDetailListNewPostConfig";
export const SET_DETAIL_NEW_POST_CONFIG = "setDetailListNewPostConfig";
export const UPDATE_DETAIL_NEW_POST_CONFIG = "updateDetailListNewPostConfig";
export const DELETE_DETAIL_NEW_POST_CONFIG = "deleteDetailListNewPostConfig";
export const UPDATE_SALE_NEW_POST_CONFIG = "updateSaleNewPostConfig";





const state = {
    newPostConfigs: [],
    newPostConfig: {},
    
};

const getters = {
    newPostConfigs(state) {
        return state.newPostConfigs;
    },
    newPostConfig(state) {
        return state.newPostConfig;
    },
  
};

const actions = {
    [GET_NEW_POST_CONFIG](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_NEW_POST_CONFIGS, payload).then(({ data }) => {
                if (data.status) {
                    
                    context.commit(SET_NEW_POST_CONFIG, data);
                   
                }
                resolve(data);
            });
        });
    },

    // [GET_DATA_SEARCH](context, payload) {
    //     return new Promise(resolve => {
    //         ApiService.query(API.GET_LIST_CATEGORY_SEARCH, payload).then(({ data }) => {
    //             console.log(data);
    //             if (data.status) {
    //                 context.commit(SET_DATA_SEARCH, data.data.categories);
    //             }
    //             resolve(data);
    //         });
    //     });
    // },

    [GET_DETAIL_NEW_POST_CONFIG](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_NEW_POST_CONFIGS}/${id}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DETAIL_NEW_POST_CONFIG, data);
                }
                resolve(data);
            });
        });
    },
    [ADD_NEW_POST_CONFIG](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.GET_NEW_POST_CONFIGS}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    // [SAVE_CATEGORY](context, payload) {
    //     return new Promise((resolve, reject) => {
    //         ApiService.post(`${API.SAVE_CATEGORY}`, payload)
    //             .then((data) => {
    //                 resolve(data)
    //             })
    //             .catch((err) => {
    //                 console.log(err)
    //                 reject(err);
    //             });
    //     });
    // },
    [UPDATE_DETAIL_NEW_POST_CONFIG](context, payload) {
        console.log(payload)
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_DETAIL_NEW_POST_CONFIGS}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [UPDATE_SALE_NEW_POST_CONFIG](context, payload) {
        console.log(payload)
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_DETAIL_NEW_POST_CONFIGS}/${payload.id}`, 'sale', payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [DELETE_DETAIL_NEW_POST_CONFIG](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_DETAIL_NEW_POST_CONFIGS}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_NEW_POST_CONFIG](state, data) {
       state.newPostConfigs =  data.data
    },
    [SET_DETAIL_NEW_POST_CONFIG](state, data) {
        state.newPostConfig = data.data;
    },


    
};

export default {
    state,
    actions,
    mutations,
    getters
};